"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getById = void 0;
const data_types_1 = require("./data-types");
function getById(id) {
    var _a;
    return (_a = data_types_1.dataTypes.find(x => x.id === id)) !== null && _a !== void 0 ? _a : null;
}
exports.getById = getById;
//# sourceMappingURL=get.js.map